import { getUserWixId } from 'modules/user/utils';
import { checkIsAuthenticated } from './checkIsAuthenticated';

export const checkAuth = ({ authentication, profile: { data: profile }, userGet: { isFetching } = {} }) => {
  const isAuthenticated = checkIsAuthenticated({ authentication, profile });
  const { user } = authentication;

  return {
    isAuthenticated,
    // user && !getUserWixId(profile) - it should work at the very first moment when the app is bootstrapping
    isAuthPending: (!isAuthenticated && ((user && !getUserWixId(profile)) || isFetching)),
  };
};
